<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-p4_us-bases-box">
  <!-- Artboard: xs -->
  <div
    id="g-p4_us-bases-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.5;"
  >
    <div
      id="g-p4_us-bases-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p4_us-bases-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:2.2218%;margin-top:-7.7px;left:2.1813%;width:262px;"
    >
      <p class="g-pstyle0">Facilities US military operates from</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:5.5551%;margin-top:-7.7px;left:7.4911%;width:40px;"
    >
      <p class="g-pstyle1">Air</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:5.5551%;margin-top:-7.7px;left:22.5342%;width:60px;"
    >
      <p class="g-pstyle1">Naval</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:5.5551%;margin-top:-7.7px;left:43.0096%;width:57px;"
    >
      <p class="g-pstyle1">Army</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:5.5551%;margin-top:-7.7px;left:62.6045%;width:94px;"
    >
      <p class="g-pstyle1">Joint bases</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:11.275%;margin-top:-6.4px;left:83.5047%;margin-left:-41.5px;width:83px;"
    >
      <p class="g-pstyle2">Uzbekistan</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:15.2144%;margin-top:-6.4px;left:14.4213%;margin-left:-30px;width:60px;"
    >
      <p class="g-pstyle2">TURKEY</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:17.4871%;margin-top:-6.4px;left:82.9588%;margin-left:-49px;width:98px;"
    >
      <p class="g-pstyle2">Turkmenistan</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:23.3962%;margin-top:-6.4px;left:64.4346%;width:54px;"
    >
      <p class="g-pstyle3">Tehran</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:23.6992%;margin-top:-6.4px;left:29.6678%;margin-left:-25px;width:50px;"
    >
      <p class="g-pstyle2">Syria</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:25.3027%;margin-top:-5px;left:70.191%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle4">Iran</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:25.9088%;margin-top:-5px;right:78.5272%;width:74px;"
    >
      <p class="g-pstyle5">Israel</p>
    </div>
    <div
      id="g-ai0-13"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:27.3356%;margin-top:-6.4px;right:82.2279%;width:59px;"
    >
      <p class="g-pstyle6">Tel-Aviv</p>
    </div>
    <div
      id="g-ai0-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:29.4568%;margin-top:-6.4px;left:44.0844%;margin-left:-23px;width:46px;"
    >
      <p class="g-pstyle2">Iraq</p>
    </div>
    <div
      id="g-ai0-15"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:30.8205%;margin-top:-6.4px;left:19.2664%;width:61px;"
    >
      <p class="g-pstyle7">Jordan</p>
    </div>
    <div
      id="g-ai0-16"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:31.8811%;margin-top:-6.4px;right:53.2836%;width:59px;"
    >
      <p class="g-pstyle8">Kuwait</p>
    </div>
    <div
      id="g-ai0-17"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:33.0932%;margin-top:-6.4px;right:24.0538%;width:66px;"
    >
      <p class="g-pstyle8">Bahrain</p>
    </div>
    <div
      id="g-ai0-18"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:35.6689%;margin-top:-6.4px;right:21.4098%;width:54px;"
    >
      <p class="g-pstyle8">Qatar</p>
    </div>
    <div
      id="g-ai0-19"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:37.4871%;margin-top:-12.4px;left:35.3761%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle2">Saudi</p>
      <p class="g-pstyle2">Arabia</p>
    </div>
    <div
      id="g-ai0-20"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:42.9417%;margin-top:-6.4px;left:69.8187%;margin-left:-20.5px;width:41px;"
    >
      <p class="g-pstyle2">UAE</p>
    </div>
    <div
      id="g-ai0-21"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:49.9114%;margin-top:-6.4px;left:72.4929%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle2">Oman</p>
    </div>
    <div
      id="g-ai0-22"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:55.2144%;margin-top:-6.4px;left:50.9344%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle2">Yemen</p>
    </div>
    <div
      id="g-ai0-23"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:59.6083%;margin-top:-6.4px;right:59.4968%;width:66px;"
    >
      <p class="g-pstyle8">Djibouti</p>
    </div>
    <div
      id="g-ai0-24"
      class="g-artwork g-aiAbs g-aiPointText"
      style="bottom:28.8188%;left:6.7284%;width:158px;"
    >
      <p class="g-pstyle9">Incirlik Air Base</p>
      <p class="g-pstyle10">Stores over 50 B-61</p>
      <p class="g-pstyle10">nuclear gravity bombs.</p>
    </div>
    <div
      id="g-ai0-25"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:67.9668%;margin-top:-21.6px;left:61.9129%;width:138px;"
    >
      <p class="g-pstyle9">Al Udeid Air Base</p>
      <p class="g-pstyle10">Largest U.S. base in</p>
      <p class="g-pstyle10">the Middle East.</p>
    </div>
    <div
      id="g-ai0-26"
      class="g-artwork g-aiAbs g-aiPointText"
      style="bottom:19.3018%;left:7.1143%;width:144px;"
    >
      <p class="g-pstyle9">Izmir Air Station</p>
      <p class="g-pstyle10">Supports numerous</p>
      <p class="g-pstyle10">U.S./NATO missions</p>
      <p class="g-pstyle10">in the area.</p>
    </div>
    <div
      id="g-ai0-27"
      class="g-artwork g-aiAbs g-aiPointText"
      style="bottom:18.0375%;left:62.0893%;width:136px;"
    >
      <p class="g-pstyle9">Al Dhafra Air Base</p>
      <p class="g-pstyle10">Busiest U.S. base</p>
      <p class="g-pstyle10">in the world for</p>
      <p class="g-pstyle10">surveillance flights.</p>
    </div>
    <div
      id="g-ai0-28"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:85.5426%;margin-top:-21.6px;left:7.1143%;width:166px;"
    >
      <p class="g-pstyle9">Erbil Air Base</p>
      <p class="g-pstyle10">Recent target of</p>
      <p class="g-pstyle10">Iranian retaliatory attack</p>
    </div>
    <div
      id="g-ai0-29"
      class="g-artwork g-aiAbs g-aiPointText"
      style="bottom:4.9256%;left:62.8445%;width:142px;"
    >
      <p class="g-pstyle9">Fujairah Naval Base</p>
      <p class="g-pstyle10">Offers a logistical</p>
      <p class="g-pstyle10">&ldquo;land link&rdquo; should</p>
      <p class="g-pstyle10">the Strait of Hormuz</p>
      <p class="g-pstyle10">be closed.</p>
    </div>
    <div
      id="g-ai0-30"
      class="g-artwork g-aiAbs g-aiPointText"
      style="bottom:0.6384%;right:40.5134%;width:206px;"
    >
      <p class="g-pstyle11">Naval Support Activity Bahrain</p>
      <p class="g-pstyle12">Central Command of the U.S.</p>
      <p class="g-pstyle12">Naval Forces, headquarters</p>
      <p class="g-pstyle12">of the U.S. 5th Fleet.</p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-p4_us-bases-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.86440677966102;"
  >
    <div
      id="g-p4_us-bases-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p4_us-bases-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:3.8413%;margin-top:-7.7px;left:43.9932%;width:262px;"
    >
      <p class="g-pstyle0">Facilities US military operates from</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:7.5701%;margin-top:-7.7px;left:70.6076%;width:57px;"
    >
      <p class="g-pstyle1">Army</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:7.5701%;margin-top:-7.7px;left:47.6248%;width:40px;"
    >
      <p class="g-pstyle1">Air</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:7.5701%;margin-top:-7.7px;left:57.3587%;width:60px;"
    >
      <p class="g-pstyle1">Naval</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:7.5701%;margin-top:-7.7px;left:83.2866%;width:94px;"
    >
      <p class="g-pstyle1">Joint bases</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="bottom:77.6569%;left:7.4155%;width:144px;"
    >
      <p class="g-pstyle2">Izmir Air Station</p>
      <p class="g-pstyle3">Supports numerous</p>
      <p class="g-pstyle3">U.S./NATO missions</p>
      <p class="g-pstyle3">in the area.</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:14.9149%;margin-top:-7px;left:87.1266%;margin-left:-55.5px;width:111px;"
    >
      <p class="g-pstyle4">Uzbekistan</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-artwork g-aiAbs g-aiPointText"
      style="bottom:70.0293%;left:26.6303%;width:158px;"
    >
      <p class="g-pstyle2">Incirlik Air Base</p>
      <p class="g-pstyle3">Stores over 50 B-61</p>
      <p class="g-pstyle3">nuclear gravity bombs.</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:25.0844%;margin-top:-7px;left:82.0615%;margin-left:-67px;width:134px;"
    >
      <p class="g-pstyle4">Turkmenistan</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:25.2539%;margin-top:-7px;left:17.5648%;margin-left:-38.5px;width:77px;"
    >
      <p class="g-pstyle4">TURKEY</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:29.0815%;margin-top:-21.6px;left:54.0702%;width:166px;"
    >
      <p class="g-pstyle2">Erbil Air Base</p>
      <p class="g-pstyle3">Recent target of</p>
      <p class="g-pstyle3">Iranian retaliatory attack</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:34.9997%;margin-top:-5.5px;left:64.3501%;width:57px;"
    >
      <p class="g-pstyle5">Tehran</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:35.4234%;margin-top:-7px;left:31.3427%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle4">Syria</p>
    </div>
    <div
      id="g-ai1-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:37.7256%;margin-top:-7.6px;left:68.6508%;margin-left:-32px;width:64px;"
    >
      <p class="g-pstyle6">Iran</p>
    </div>
    <div
      id="g-ai1-15"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:38.912%;margin-top:-7.6px;right:77.2544%;width:83px;"
    >
      <p class="g-pstyle7">Israel</p>
    </div>
    <div
      id="g-ai1-16"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:41.2709%;margin-top:-5.5px;right:80.0367%;width:62px;"
    >
      <p class="g-pstyle8">Tel-Aviv</p>
    </div>
    <div
      id="g-ai1-17"
      class="g-artwork g-aiAbs g-aiPointText"
      style="bottom:48.2726%;left:58.1081%;width:206px;"
    >
      <p class="g-pstyle2">Naval Support Activity Bahrain</p>
      <p class="g-pstyle3">Central Command of the U.S.</p>
      <p class="g-pstyle3">Naval Forces, headquarters</p>
      <p class="g-pstyle3">of the U.S. 5th Fleet.</p>
    </div>
    <div
      id="g-ai1-18"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:44.9149%;margin-top:-7px;left:44.9824%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle4">Iraq</p>
    </div>
    <div
      id="g-ai1-19"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:46.1014%;margin-top:-7px;left:21.432%;width:78px;"
    >
      <p class="g-pstyle9">Jordan</p>
    </div>
    <div
      id="g-ai1-20"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:48.9827%;margin-top:-7px;right:52.3438%;width:76px;"
    >
      <p class="g-pstyle10">Kuwait</p>
    </div>
    <div
      id="g-ai1-21"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:57.6969%;margin-top:-13.4px;left:36.8277%;margin-left:-37.5px;width:75px;"
    >
      <p class="g-pstyle4">Saudi</p>
      <p class="g-pstyle4">Arabia</p>
    </div>
    <div
      id="g-ai1-22"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:56.6098%;margin-top:-7px;right:43.3245%;width:86px;"
    >
      <p class="g-pstyle10">Bahrain</p>
    </div>
    <div
      id="g-ai1-23"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:56.8546%;margin-top:-5.4px;left:88.7883%;margin-left:-52px;width:104px;"
    >
      <p class="g-pstyle11">Strait of Hormuz</p>
    </div>
    <div
      id="g-ai1-24"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:66.4403%;margin-top:-7px;left:70.3983%;margin-left:-24.5px;width:49px;"
    >
      <p class="g-pstyle4">UAE</p>
    </div>
    <div
      id="g-ai1-25"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:67.2878%;margin-top:-7px;right:38.0773%;width:67px;"
    >
      <p class="g-pstyle10">Qatar</p>
    </div>
    <div
      id="g-ai1-26"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:75.3527%;margin-top:-21.6px;left:7.4155%;width:138px;"
    >
      <p class="g-pstyle2">Al Udeid Air Base</p>
      <p class="g-pstyle3">Largest U.S. base in</p>
      <p class="g-pstyle3">the Middle East.</p>
    </div>
    <div
      id="g-ai1-27"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:78.4742%;margin-top:-7px;left:71.9571%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle4">Oman</p>
    </div>
    <div
      id="g-ai1-28"
      class="g-artwork g-aiAbs g-aiPointText"
      style="bottom:11.6458%;left:7.4155%;width:195px;"
    >
      <p class="g-pstyle2">Al Dhafra Air Base</p>
      <p class="g-pstyle3">Busiest U.S. base in the world</p>
      <p class="g-pstyle3">for surveillance flights.</p>
    </div>
    <div
      id="g-ai1-29"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:85.0844%;margin-top:-7px;left:51.4118%;margin-left:-34.5px;width:69px;"
    >
      <p class="g-pstyle4">Yemen</p>
    </div>
    <div
      id="g-ai1-30"
      class="g-artwork g-aiAbs g-aiPointText"
      style="bottom:5.9292%;left:65.6863%;width:189px;"
    >
      <p class="g-pstyle2">Fujairah Naval Base</p>
      <p class="g-pstyle3">Offers a logistical &ldquo;land link&rdquo;</p>
      <p class="g-pstyle3">should the Strait of Hormuz</p>
      <p class="g-pstyle3">be closed.</p>
    </div>
    <div
      id="g-ai1-31"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:95.0844%;margin-top:-7px;right:58.1798%;width:87px;"
    >
      <p class="g-pstyle10">Djibouti</p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-p4_us-bases-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.98590631597874;"
  >
    <div
      id="g-p4_us-bases-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p4_us-bases-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:3.2485%;margin-top:-7.7px;left:50.7237%;width:292px;"
    >
      <p class="g-pstyle0">Facilities US military operates from</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.5349%;margin-top:-7.7px;left:74.3197%;width:61px;"
    >
      <p class="g-pstyle1">Army</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.5349%;margin-top:-7.7px;left:53.5301%;width:43px;"
    >
      <p class="g-pstyle1">Air</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.5349%;margin-top:-7.7px;left:62.5669%;width:64px;"
    >
      <p class="g-pstyle1">Naval</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.5349%;margin-top:-7.7px;left:85.6323%;width:103px;"
    >
      <p class="g-pstyle1">Joint bases</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:15.0124%;margin-top:-7.5px;left:74.6588%;margin-left:-55.5px;width:111px;"
    >
      <p class="g-pstyle2">Uzbekistan</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:19.5062%;margin-top:-28.6px;left:5.3874%;width:144px;"
    >
      <p class="g-pstyle3">Izmir Air Station</p>
      <p class="g-pstyle4">Supports numerous</p>
      <p class="g-pstyle4">U.S./NATO missions</p>
      <p class="g-pstyle4">in the area.</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:22.7801%;margin-top:-7.5px;left:25.2314%;margin-left:-38.5px;width:77px;"
    >
      <p class="g-pstyle2">TURKEY</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:25.1702%;margin-top:-7.5px;left:70.2322%;margin-left:-67px;width:134px;"
    >
      <p class="g-pstyle2">Turkmenistan</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:28.7677%;margin-top:-21.6px;left:21.8262%;width:158px;"
    >
      <p class="g-pstyle3">Incirlik Air Base</p>
      <p class="g-pstyle4">Stores over 50 B-61</p>
      <p class="g-pstyle4">nuclear gravity bombs.</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:28.7677%;margin-top:-21.6px;left:45.7906%;width:166px;"
    >
      <p class="g-pstyle3">Erbil Air Base</p>
      <p class="g-pstyle4">Recent target of</p>
      <p class="g-pstyle4">Iranian retaliatory attack</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:34.9546%;margin-top:-6px;left:54.7686%;width:57px;"
    >
      <p class="g-pstyle5">Tehran</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:35.328%;margin-top:-7.5px;left:25.943%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle2">Syria</p>
    </div>
    <div
      id="g-ai2-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:37.5064%;margin-top:-8.1px;left:58.2167%;margin-left:-32px;width:64px;"
    >
      <p class="g-pstyle6">Iran</p>
    </div>
    <div
      id="g-ai2-15"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:39.4484%;margin-top:-8.1px;right:81.5672%;width:83px;"
    >
      <p class="g-pstyle7">Israel</p>
    </div>
    <div
      id="g-ai2-16"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:39.5107%;margin-top:-7.5px;left:83.4924%;margin-left:-61.5px;width:123px;"
    >
      <p class="g-pstyle2">Afghanistan</p>
    </div>
    <div
      id="g-ai2-17"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:41.2285%;margin-top:-6px;right:83.997%;width:62px;"
    >
      <p class="g-pstyle8">Tel-Aviv</p>
    </div>
    <div
      id="g-ai2-18"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:44.8883%;margin-top:-7.5px;left:37.8502%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle2">Iraq</p>
    </div>
    <div
      id="g-ai2-19"
      class="g-artwork g-aiAbs g-aiPointText"
      style="bottom:46.6928%;left:54.4175%;width:206px;"
    >
      <p class="g-pstyle3">Naval Support Activity Bahrain</p>
      <p class="g-pstyle4">Central Command of the U.S.</p>
      <p class="g-pstyle4">Naval Forces, headquarters</p>
      <p class="g-pstyle4">of the U.S. 5th Fleet.</p>
    </div>
    <div
      id="g-ai2-20"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:46.0834%;margin-top:-7.5px;left:17.2862%;width:78px;"
    >
      <p class="g-pstyle9">Jordan</p>
    </div>
    <div
      id="g-ai2-21"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:48.9216%;margin-top:-7.5px;right:59.8121%;width:76px;"
    >
      <p class="g-pstyle10">Kuwait</p>
    </div>
    <div
      id="g-ai2-22"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:53.2536%;margin-top:-7.5px;left:88.4224%;margin-left:-45.5px;width:91px;"
    >
      <p class="g-pstyle2">Pakistan</p>
    </div>
    <div
      id="g-ai2-23"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:57.6227%;margin-top:-14.7px;left:30.7284%;margin-left:-37.5px;width:75px;"
    >
      <p class="g-pstyle2">Saudi</p>
      <p class="g-pstyle2">Arabia</p>
    </div>
    <div
      id="g-ai2-24"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:56.5399%;margin-top:-7.5px;right:51.9374%;width:86px;"
    >
      <p class="g-pstyle10">Bahrain</p>
    </div>
    <div
      id="g-ai2-25"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:56.7674%;margin-top:-6px;left:76.1359%;margin-left:-57.5px;width:115px;"
    >
      <p class="g-pstyle11">Strait of Hormuz</p>
    </div>
    <div
      id="g-ai2-26"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:65.6521%;margin-top:-7.5px;right:47.3438%;width:67px;"
    >
      <p class="g-pstyle10">Qatar</p>
    </div>
    <div
      id="g-ai2-27"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:66.399%;margin-top:-7.5px;left:60.0488%;margin-left:-24.5px;width:49px;"
    >
      <p class="g-pstyle2">UAE</p>
    </div>
    <div
      id="g-ai2-28"
      class="g-artwork g-aiAbs g-aiPointText"
      style="bottom:26.054%;left:74.0798%;width:189px;"
    >
      <p class="g-pstyle3">Fujairah Naval Base</p>
      <p class="g-pstyle4">Offers a logistical &ldquo;land link&rdquo;</p>
      <p class="g-pstyle4">should the Strait of Hormuz</p>
      <p class="g-pstyle4">be closed.</p>
    </div>
    <div
      id="g-ai2-29"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:72.3866%;margin-top:-21.6px;left:48.6815%;width:138px;"
    >
      <p class="g-pstyle3">Al Udeid Air Base</p>
      <p class="g-pstyle4">Largest U.S. base in</p>
      <p class="g-pstyle4">the Middle East.</p>
    </div>
    <div
      id="g-ai2-30"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:77.7519%;margin-top:-7.5px;left:63.2949%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle2">Oman</p>
    </div>
    <div
      id="g-ai2-31"
      class="g-artwork g-aiAbs g-aiPointText"
      style="bottom:12.3125%;left:65.753%;width:195px;"
    >
      <p class="g-pstyle3">Al Dhafra Air Base</p>
      <p class="g-pstyle4">Busiest U.S. base in the world</p>
      <p class="g-pstyle4">for surveillance flights.</p>
    </div>
    <div
      id="g-ai2-32"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:84.9221%;margin-top:-7.5px;left:43.4732%;margin-left:-34.5px;width:69px;"
    >
      <p class="g-pstyle2">Yemen</p>
    </div>
    <div
      id="g-ai2-33"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.9305%;margin-top:-7.5px;right:64.9003%;width:87px;"
    >
      <p class="g-pstyle10">Djibouti</p>
    </div>
  </div>

  <!-- Artboard: lg -->
  <div
    id="g-p4_us-bases-lg"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.09756470748077;"
  >
    <div
      id="g-p4_us-bases-lg-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p4_us-bases-lg.jpg);"
    ></div>
    <div
      id="g-ai4-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:2.5665%;margin-top:-7.7px;left:65.0297%;width:292px;"
    >
      <p class="g-pstyle0">Facilities US military operates from</p>
    </div>
    <div
      id="g-ai4-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:5.1629%;margin-top:-7.7px;left:81.7752%;width:61px;"
    >
      <p class="g-pstyle1">Army</p>
    </div>
    <div
      id="g-ai4-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:5.1629%;margin-top:-7.7px;left:67.0214%;width:43px;"
    >
      <p class="g-pstyle1">Air</p>
    </div>
    <div
      id="g-ai4-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:5.1629%;margin-top:-7.7px;left:73.4346%;width:64px;"
    >
      <p class="g-pstyle1">Naval</p>
    </div>
    <div
      id="g-ai4-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:5.1629%;margin-top:-7.7px;left:89.8035%;width:103px;"
    >
      <p class="g-pstyle1">Joint bases</p>
    </div>
    <div
      id="g-ai4-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:12.9915%;margin-top:-10.1px;left:75.2665%;margin-left:-63px;width:126px;"
    >
      <p class="g-pstyle2">Uzbekistan</p>
    </div>
    <div
      id="g-ai4-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:21.5478%;margin-top:-28.6px;left:11.0793%;width:144px;"
    >
      <p class="g-pstyle3">Izmir Air Station</p>
      <p class="g-pstyle4">Supports numerous</p>
      <p class="g-pstyle4">U.S./NATO missions</p>
      <p class="g-pstyle4">in the area.</p>
    </div>
    <div
      id="g-ai4-8"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:21.0167%;margin-top:-10.1px;left:28.558%;margin-left:-43px;width:86px;"
    >
      <p class="g-pstyle2">TURKEY</p>
    </div>
    <div
      id="g-ai4-9"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:23.3771%;margin-top:-10.1px;left:71.1535%;margin-left:-76px;width:152px;"
    >
      <p class="g-pstyle2">Turkmenistan</p>
    </div>
    <div
      id="g-ai4-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:27.4487%;margin-top:-21.6px;left:43.1749%;width:166px;"
    >
      <p class="g-pstyle3">Erbil Air Base</p>
      <p class="g-pstyle4">Recent target of</p>
      <p class="g-pstyle4">Iranian retaliatory attack</p>
    </div>
    <div
      id="g-ai4-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:28.7469%;margin-top:-21.6px;left:26.4509%;width:158px;"
    >
      <p class="g-pstyle3">Incirlik Air Base</p>
      <p class="g-pstyle4">Stores over 50 B-61</p>
      <p class="g-pstyle4">nuclear gravity bombs.</p>
    </div>
    <div
      id="g-ai4-12"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:33.4676%;margin-top:-7.6px;left:56.9885%;width:63px;"
    >
      <p class="g-pstyle3">Tehran</p>
    </div>
    <div
      id="g-ai4-13"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:33.7626%;margin-top:-10.1px;left:30.5206%;margin-left:-35px;width:70px;"
    >
      <p class="g-pstyle2">Syria</p>
    </div>
    <div
      id="g-ai4-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:35.8475%;margin-top:-10.7px;left:59.9857%;margin-left:-38px;width:76px;"
    >
      <p class="g-pstyle5">Iran</p>
    </div>
    <div
      id="g-ai4-15"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:37.9718%;margin-top:-10.7px;right:76.434%;width:100px;"
    >
      <p class="g-pstyle6">Israel</p>
    </div>
    <div
      id="g-ai4-16"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:38.0113%;margin-top:-10.1px;left:83.3805%;margin-left:-70px;width:140px;"
    >
      <p class="g-pstyle2">Afghanistan</p>
    </div>
    <div
      id="g-ai4-17"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:39.8405%;margin-top:-7.6px;right:78.5841%;width:69px;"
    >
      <p class="g-pstyle7">Tel-Aviv</p>
    </div>
    <div
      id="g-ai4-18"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:43.5581%;margin-top:-10.1px;left:41.4098%;margin-left:-30.5px;width:61px;"
    >
      <p class="g-pstyle2">Iraq</p>
    </div>
    <div
      id="g-ai4-19"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:44.7383%;margin-top:-10.1px;left:22.559%;width:87px;"
    >
      <p class="g-pstyle8">Jordan</p>
    </div>
    <div
      id="g-ai4-20"
      class="g-text g-aiAbs g-aiPointText"
      style="bottom:47.7911%;left:56.6659%;width:206px;"
    >
      <p class="g-pstyle3">Naval Support Activity Bahrain</p>
      <p class="g-pstyle4">Central Command of the U.S.</p>
      <p class="g-pstyle4">Naval Forces, headquarters</p>
      <p class="g-pstyle4">of the U.S. 5th Fleet.</p>
    </div>
    <div
      id="g-ai4-21"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:47.6887%;margin-top:-10.1px;right:56.4055%;width:85px;"
    >
      <p class="g-pstyle9">Kuwait</p>
    </div>
    <div
      id="g-ai4-22"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:52.0554%;margin-top:-10.1px;left:87.9284%;margin-left:-51.5px;width:103px;"
    >
      <p class="g-pstyle2">Pakistan</p>
    </div>
    <div
      id="g-ai4-23"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:56.5851%;margin-top:-19.5px;left:34.8591%;margin-left:-41.5px;width:83px;"
    >
      <p class="g-pstyle2">Saudi</p>
      <p class="g-pstyle2">Arabia</p>
    </div>
    <div
      id="g-ai4-24"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:55.4779%;margin-top:-10.1px;right:49.2451%;width:96px;"
    >
      <p class="g-pstyle9">Bahrain</p>
    </div>
    <div
      id="g-ai4-25"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:55.6451%;margin-top:-7.5px;left:76.6489%;margin-left:-71.5px;width:143px;"
    >
      <p class="g-pstyle10">Strait of Hormuz</p>
    </div>
    <div
      id="g-ai4-26"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:64.8013%;margin-top:-10.1px;right:44.8927%;width:75px;"
    >
      <p class="g-pstyle9">Qatar</p>
    </div>
    <div
      id="g-ai4-27"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:65.5094%;margin-top:-10.1px;left:61.8104%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle2">UAE</p>
    </div>
    <div
      id="g-ai4-28"
      class="g-text g-aiAbs g-aiPointText"
      style="bottom:28.5195%;left:79.0412%;width:189px;"
    >
      <p class="g-pstyle3">Fujairah Naval Base</p>
      <p class="g-pstyle4">Offers a logistical &ldquo;land link&rdquo;</p>
      <p class="g-pstyle4">should the Strait of Hormuz</p>
      <p class="g-pstyle4">be closed.</p>
    </div>
    <div
      id="g-ai4-29"
      class="g-text g-aiAbs g-aiPointText"
      style="top:70.8792%;margin-top:-21.6px;left:51.3971%;width:138px;"
    >
      <p class="g-pstyle3">Al Udeid Air Base</p>
      <p class="g-pstyle4">Largest U.S. base in</p>
      <p class="g-pstyle4">the Middle East.</p>
    </div>
    <div
      id="g-ai4-30"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:77.1931%;margin-top:-10.1px;left:64.8286%;margin-left:-35px;width:70px;"
    >
      <p class="g-pstyle2">Oman</p>
    </div>
    <div
      id="g-ai4-31"
      class="g-text g-aiAbs g-aiPointText"
      style="bottom:13.8286%;left:67.0782%;width:195px;"
    >
      <p class="g-pstyle3">Al Dhafra Air Base</p>
      <p class="g-pstyle4">Busiest U.S. base in the world</p>
      <p class="g-pstyle4">for surveillance flights.</p>
    </div>
    <div
      id="g-ai4-32"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:84.5102%;margin-top:-10.1px;left:46.625%;margin-left:-38.5px;width:77px;"
    >
      <p class="g-pstyle2">Yemen</p>
    </div>
    <div
      id="g-ai4-33"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.6598%;margin-top:-10.1px;right:61.0552%;width:98px;"
    >
      <p class="g-pstyle9">Djibouti</p>
    </div>
  </div>
</div>
<!-- End ai2html - 2025-06-20 14:43 -->

<!-- Generated by ai2html v0.101.0 - 2025-06-20 14:43 -->
<!-- ai file: p4_us-bases.ai -->
<style lang="scss">
  #g-p4_us-bases-box,
  #g-p4_us-bases-box .g-artboard {
    margin: 0 auto;
  }
  #g-p4_us-bases-box p {
    margin: 0;
  }
  #g-p4_us-bases-box .g-aiAbs {
    position: absolute;
  }
  #g-p4_us-bases-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-p4_us-bases-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-p4_us-bases-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-p4_us-bases-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-p4_us-bases-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-p4_us-bases-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-p4_us-bases-lg {
        display: block !important;
      }
    }
  }
  #g-p4_us-bases-xs {
    position: relative;
    overflow: hidden;
  }
  #g-p4_us-bases-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p4_us-bases-xs .g-pstyle0 {
    font-weight: 500;
    height: 14px;
    font-size: 16px;
  }
  #g-p4_us-bases-xs .g-pstyle1 {
    font-weight: 300;
    height: 14px;
    font-size: 16px;
  }
  #g-p4_us-bases-xs .g-pstyle2 {
    line-height: 12px;
    height: 12px;
    letter-spacing: 0.05em;
    font-size: 10px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-p4_us-bases-xs .g-pstyle3 {
    font-weight: 500;
    line-height: 12px;
    height: 12px;
    letter-spacing: 0.05em;
    font-size: 10px;
  }
  #g-p4_us-bases-xs .g-pstyle4 {
    font-weight: 900;
    line-height: 9px;
    height: 9px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-p4_us-bases-xs .g-pstyle5 {
    font-weight: 900;
    line-height: 9px;
    height: 9px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: right;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-p4_us-bases-xs .g-pstyle6 {
    font-weight: 500;
    line-height: 12px;
    height: 12px;
    letter-spacing: 0.05em;
    font-size: 10px;
    text-align: right;
  }
  #g-p4_us-bases-xs .g-pstyle7 {
    line-height: 12px;
    height: 12px;
    letter-spacing: 0.05em;
    font-size: 10px;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-p4_us-bases-xs .g-pstyle8 {
    line-height: 12px;
    height: 12px;
    letter-spacing: 0.05em;
    font-size: 10px;
    text-align: right;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-p4_us-bases-xs .g-pstyle9 {
    font-weight: 500;
    height: 14px;
  }
  #g-p4_us-bases-xs .g-pstyle10 {
    height: 14px;
  }
  #g-p4_us-bases-xs .g-pstyle11 {
    font-weight: 500;
    height: 14px;
    text-align: right;
  }
  #g-p4_us-bases-xs .g-pstyle12 {
    height: 14px;
    text-align: right;
  }
  #g-p4_us-bases-sm {
    position: relative;
    overflow: hidden;
  }
  #g-p4_us-bases-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p4_us-bases-sm .g-pstyle0 {
    font-weight: 500;
    height: 14px;
    font-size: 16px;
  }
  #g-p4_us-bases-sm .g-pstyle1 {
    font-weight: 300;
    height: 14px;
    font-size: 16px;
  }
  #g-p4_us-bases-sm .g-pstyle2 {
    font-weight: 500;
    height: 14px;
  }
  #g-p4_us-bases-sm .g-pstyle3 {
    height: 14px;
  }
  #g-p4_us-bases-sm .g-pstyle4 {
    line-height: 13px;
    height: 13px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-p4_us-bases-sm .g-pstyle5 {
    font-weight: 500;
    line-height: 10px;
    height: 10px;
    font-size: 12px;
  }
  #g-p4_us-bases-sm .g-pstyle6 {
    font-weight: 900;
    height: 14px;
    letter-spacing: 0.2em;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-p4_us-bases-sm .g-pstyle7 {
    font-weight: 900;
    height: 14px;
    letter-spacing: 0.2em;
    text-align: right;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-p4_us-bases-sm .g-pstyle8 {
    font-weight: 500;
    line-height: 10px;
    height: 10px;
    font-size: 12px;
    text-align: right;
  }
  #g-p4_us-bases-sm .g-pstyle9 {
    line-height: 13px;
    height: 13px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-p4_us-bases-sm .g-pstyle10 {
    line-height: 13px;
    height: 13px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: right;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-p4_us-bases-sm .g-pstyle11 {
    font-weight: 500;
    line-height: 10px;
    height: 10px;
    letter-spacing: 0.2em;
    font-size: 8px;
    text-align: center;
    color: rgb(102, 102, 102);
  }
  #g-p4_us-bases-md {
    position: relative;
    overflow: hidden;
  }
  #g-p4_us-bases-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p4_us-bases-md .g-pstyle0 {
    font-weight: 500;
    height: 14px;
    font-size: 18px;
  }
  #g-p4_us-bases-md .g-pstyle1 {
    font-weight: 300;
    height: 14px;
    font-size: 18px;
  }
  #g-p4_us-bases-md .g-pstyle2 {
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-p4_us-bases-md .g-pstyle3 {
    font-weight: 500;
    height: 14px;
  }
  #g-p4_us-bases-md .g-pstyle4 {
    height: 14px;
  }
  #g-p4_us-bases-md .g-pstyle5 {
    font-weight: 500;
    line-height: 11px;
    height: 11px;
    font-size: 12px;
  }
  #g-p4_us-bases-md .g-pstyle6 {
    font-weight: 900;
    line-height: 15px;
    height: 15px;
    letter-spacing: 0.2em;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-p4_us-bases-md .g-pstyle7 {
    font-weight: 900;
    line-height: 15px;
    height: 15px;
    letter-spacing: 0.2em;
    text-align: right;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-p4_us-bases-md .g-pstyle8 {
    font-weight: 500;
    line-height: 11px;
    height: 11px;
    font-size: 12px;
    text-align: right;
  }
  #g-p4_us-bases-md .g-pstyle9 {
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-p4_us-bases-md .g-pstyle10 {
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: right;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-p4_us-bases-md .g-pstyle11 {
    font-weight: 500;
    line-height: 11px;
    height: 11px;
    letter-spacing: 0.2em;
    font-size: 9px;
    text-align: center;
    color: rgb(102, 102, 102);
  }
  #g-p4_us-bases-lg {
    position: relative;
    overflow: hidden;
  }
  #g-p4_us-bases-lg p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p4_us-bases-lg .g-pstyle0 {
    font-weight: 500;
    height: 14px;
    font-size: 18px;
  }
  #g-p4_us-bases-lg .g-pstyle1 {
    font-weight: 300;
    height: 14px;
    font-size: 18px;
  }
  #g-p4_us-bases-lg .g-pstyle2 {
    line-height: 19px;
    height: 19px;
    letter-spacing: 0.2em;
    text-align: center;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-p4_us-bases-lg .g-pstyle3 {
    font-weight: 500;
    height: 14px;
  }
  #g-p4_us-bases-lg .g-pstyle4 {
    height: 14px;
  }
  #g-p4_us-bases-lg .g-pstyle5 {
    font-weight: 900;
    line-height: 20px;
    height: 20px;
    letter-spacing: 0.2em;
    font-size: 18px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-p4_us-bases-lg .g-pstyle6 {
    font-weight: 900;
    line-height: 20px;
    height: 20px;
    letter-spacing: 0.2em;
    font-size: 18px;
    text-align: right;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-p4_us-bases-lg .g-pstyle7 {
    font-weight: 500;
    height: 14px;
    text-align: right;
  }
  #g-p4_us-bases-lg .g-pstyle8 {
    line-height: 19px;
    height: 19px;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-p4_us-bases-lg .g-pstyle9 {
    line-height: 19px;
    height: 19px;
    letter-spacing: 0.2em;
    text-align: right;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-p4_us-bases-lg .g-pstyle10 {
    font-weight: 500;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(102, 102, 102);
  }

  /* Custom CSS */
  .g-text {
  }
</style>
